import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { logout } from 'AppSrc/core/auth/auth-actions';
import { usernameSelector } from 'AppSrc/core/auth/auth-selectors';
import {
  SilhouetteAvatar,
} from 'AppSrc/core/components/common/svg-icons';
import 'AppSrc/core/style/components/header/header-user.css';
import { Alert } from 'AppSrc/core/components/utility/alert';

const HeaderUserDisplay = ({ username, signout }) => {
  const [alertOpen, setAlertOpen] = useState(false);
  const alertData = {
    option: null,
    alertTitle: 'Are you sure you want to log out?',
    falseText: 'No',
    trueText: 'Yes',
  };
  const resolveAlert = ({ boolean }) => {
    setAlertOpen(false);
    if (boolean) {
      signout();
    }
  };
  return (
    <div className="header-user">
      <div className="avatar-wrapper">
        <SilhouetteAvatar />
      </div>
      <div
        className="header-user-options"
      >
        <button
          type="button"
        >
          <p>{username}</p>
        </button>
        <span
          className="divider"
        >
          |
        </span>
        <button
          className="logout-button"
          type="button"
          onClick={() => setAlertOpen(true)}
        >
          <p>Log out</p>
        </button>
      </div>
      {
        alertOpen && (
          <Alert
            alertData={alertData}
            resolveAlert={resolveAlert}
          />
        )
      }
    </div>
  );
};

HeaderUserDisplay.propTypes = {
  username: PropTypes.string,
  signout: PropTypes.func,
};

const mapStateToProps = (state, ownProps) => ({
  username: usernameSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  signout: () => {
    dispatch(logout());
  },
});

const HeaderUser = connect(
  mapStateToProps,
  mapDispatchToProps,
)(HeaderUserDisplay);

export {
  HeaderUserDisplay,
  HeaderUser,
};
